import apiService from '../Api'
import { IHrNoteCurrent, IHrNoteHistoryResponse } from './types'

export class HrNoteService {
  async get(jobApplicationId: number): Promise<IHrNoteCurrent> {
    return apiService.get(`/job-application/${jobApplicationId}/hr-note`).then((response) => response.data)
  }

  async history(jobApplicationId: number): Promise<IHrNoteHistoryResponse> {
    return apiService.get(`/job-application/${jobApplicationId}/hr-note/history`).then((response) => response.data)
  }

  async save(jobApplicationId: number, note: string): Promise<IHrNoteCurrent> {
    return apiService.post(`/job-application/${jobApplicationId}/hr-note`, { note }).then((response) => response.data)
  }
}
